import React, { useState } from 'react';
import './CustomPropertyDate.css';

type CustomPropertyDateProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  required?: boolean;
  minDate?: string; // Formato YYYY-MM-DD
  maxDate?: string; // Formato YYYY-MM-DD
  /** Si true, no muestra la etiqueta interna (para alinear con campos que usan CustomPropertyLabel arriba) */
  hideLabel?: boolean;
};

export const CustomPropertyDate = ({
  id,
  value,
  onChange,
  placeholder,
  required = false,
  minDate,
  maxDate,
  hideLabel = false,
}: CustomPropertyDateProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  // Calcular fecha mínima por defecto si no se proporciona (2010-01-01)
  const defaultMinDate = minDate || '2010-01-01';

  // Calcular fecha máxima por defecto si no se proporciona (año actual + 10 años)
  const defaultMaxDate = maxDate || `${new Date().getFullYear() + 10}-12-31`;

  return (
    <div className={`container__input ${hideLabel ? 'custom-date--external-label' : ''}`}>
      <div className={`custom-date-wrapper ${isFocused ? 'focused' : ''}`}>
        <input
          id={id}
          type="date"
          className="custom-date-input"
          value={value}
          onChange={handleDateChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          min={defaultMinDate}
          max={defaultMaxDate}
          required={required}
          placeholder={placeholder}
        />
        {!hideLabel && (
          <label
            className={`custom-date-label ${value ? 'has-value' : ''}`}
            htmlFor={id}
          >
            {placeholder}
            {required && <span className="required-asterisk"> *</span>}
          </label>
        )}
      </div>
    </div>
  );
};
